module.exports = __webpack_public_path__ + "static/media/condensed3BetaBadges.673aac8f.svg";